import { render, staticRenderFns } from "./addLocationForm.vue?vue&type=template&id=80a75e32&"
import script from "./addLocationForm.vue?vue&type=script&lang=js&"
export * from "./addLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports